
import barba from '@barba/core';
import Swiper from 'swiper';

export default class{

	constructor(){
        this.breakPoint = 991;

        barba.hooks.afterOnce((data) => {
            this.heroSlider()
            this.companySlider()
            this.outlineSlider()
            this.strengthSlider01()
            this.strengthSlider02()
            this.indexSlider()
            this.blogSlider()
        })
        barba.hooks.leave((data) => {
            window.removeEventListener('resize',this.resize.bind(this))
        })
        barba.hooks.after((data) => {
            this.heroSlider()
            this.companySlider()
            this.outlineSlider()
            this.strengthSlider01()
            this.strengthSlider02()
            this.indexSlider()
            this.blogSlider()
        });
    }
    
    blogSlider(){
        const blog_thumbnails = document.querySelectorAll('.blog-slider-thumbnails a');
        const blogSlider = new Swiper('.js-blog__slider', {
            loop: true,
            speed:400,
            easing:"linear",
            // loopAdditionalSlides : 5,
            // slidesPerView: 'auto',
            spaceBetween: 20,
            simulateTouch:true,
            centeredSlides: false,
            // pagination: {
            //   el: '.swiper-pagination',
            //   type: 'bullets',
            //   clickable: true
            // },
            autoplay: {
                delay: 3000,
                disableOnInteraction:false
            },
            breakpoints: {
                576: {
                    slidesPerView: 'auto',
                    spaceBetween:  40,
                }
            }
        });
        
        const blogThumbnailAddEvent = (el,i) => {
            el.addEventListener('click',function(e){
                e.preventDefault();
                blogSlider.slideTo(i+1);
            })
        }

        for(var i = 0; i <  blog_thumbnails.length; i++){
            blogThumbnailAddEvent( blog_thumbnails[i],i);
        }
    }
    heroSlider(){
        new Swiper ('#l-hero__slider',{
            loop: true,
            effect :'fade',
            speed: 100,
            allowTouchMove :false,
            simulateTouch:false,
            autoplay: {
                delay: 1000,
                disableOnInteraction:false
            }
        })
    }

    companySlider(){
        new Swiper ('#p-company__slider',{
            loop: true,
            speed: 800,
            allowTouchMove :false,
            simulateTouch:false,
            navigation: {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev',
            },
            autoplay: {
                delay: 4000,
                disableOnInteraction:false
            }
        })
    }

    outlineSlider(){
        new Swiper ('#p-outline__slider',{
            loop: true,
            effect :'fade',
            speed: 4000,
            allowTouchMove :false,
            simulateTouch:false,
            autoplay: {
                delay: 400,
                disableOnInteraction:false
            }
        })
    }

    strengthSlider01(){
        new Swiper ('#p-strength-slide01',{
            loop: true,
            effect :'fade',
            speed: 800,
            allowTouchMove :false,
            simulateTouch:false,
            pagination: {
              el: '.swiper-pagination',
              type: 'bullets',
              clickable: true
            },
            autoplay: {
                delay: 4000,
                disableOnInteraction:false
            }
        })
    }
    strengthSlider02(){
        new Swiper ('#p-strength-slide02',{
            loop: true,
            effect :'fade',
            speed: 800,
            allowTouchMove :false,
            simulateTouch:false,
            pagination: {
              el: '.swiper-pagination',
              type: 'bullets',
              clickable: true
            },
            autoplay: {
                delay: 4000,
                disableOnInteraction:false
            }
        })
    }
    indexSlider(){
        if( this.breakPoint < window.innerWidth){
            this.mySwiperBool = false;
        }else{
            this.createSwipter();
            this.mySwiperBool = true;
        }
        window.addEventListener('resize',this.resize.bind(this))
    }
    createSwipter(){
        this.indexSwiper01 = new Swiper('#p-index__company--slider', {
            breakpoints: {
                768: {
                    slidesPerView: 2.8,
                },
                576: {
                    slidesPerView: 1.8,
                }
            },
            slidesPerView: 1.2,
            freeMode: true,
            scrollbar: {
                el: ".swiper-scrollbar.--company",
                draggable: false,
            },
            spaceBetween: 0
        })

        this.indexSwiper02 = new Swiper('#p-index__service--slider', {
            breakpoints: {
                768: {
                    slidesPerView: 2.8,
                },
                576: {
                    slidesPerView: 1.8,
                }
            },
            slidesPerView: 1.2,
            freeMode: true,
            scrollbar: {
                el: ".swiper-scrollbar.--service",
                draggable: false,
            },
            spaceBetween: 0
        });
    }
    resize(){
        if( this.breakPoint < window.innerWidth &&  this.mySwiperBool){
            this.indexSwiper01.destroy(false,true);
            this.indexSwiper02.destroy(false,true);
            this.mySwiperBool = false;
        }else if( this.breakPoint >= window.innerWidth && !( this.mySwiperBool)){
            this.createSwipter();
            this.mySwiperBool = true;
        }
    }
}